<script setup>
import { __ } from 'JIX/gettext';
import { ref } from 'vue';
import SvgIcon from 'JIX/components/SvgIcon.vue';
import JobsearchNearLocation from './JobsearchNearLocation.vue';
import 'icons/geolocation.svg';
import 'icons/button-arrow-right.svg';
import { useStore } from 'vuex';
import { mapParam } from 'JIX/jobsearch/utils';
import { paramIconMap } from './constants';

const props = defineProps({
    selectedIndex: {
        type: [Number, null],
        default: null
    },
    name: {
        type: String,
        required: true,
    },
});

const show = defineModel('show', {
    type: Boolean,
    default: true,
});

const showNearLocationSubmenu = ref(false);

const store = useStore();

const address = mapParam(store, 'address');
const radius = mapParam(store, 'radius');

const emit = defineEmits(['close']);

/** Array of functions that are called when its corresponding selectable item is clicked, using mouse or keyboard */
const clickHandlers = [];

const toggleNearlocationSubmenuIndex = 0;
clickHandlers[toggleNearlocationSubmenuIndex] = () => showNearLocationSubmenu.value = !showNearLocationSubmenu.value;

defineExpose({
    numSelectableItems: clickHandlers.length,
    clickHandlers,
    name: props.name,
    show,
    hasContent: true,
    showNearLocationSubmenu,
});

</script>

<template>
    <div v-show="show" :class="{'jobsearch-dropdown-section': show}">
        <template v-if="!showNearLocationSubmenu">
            <div class="category-header jobsearch-dropdown-section__header">
                {{ __('Radius') }}
            </div>
            <ul>
                <li
                    class="jobsearch-dropdown-section__suggestion d-flex align-items-center justify-content-between"
                    @click.prevent="clickHandlers[toggleNearlocationSubmenuIndex]"
                    :class="{ 'jobsearch-dropdown-section__suggestion--selected': selectedIndex === toggleNearlocationSubmenuIndex }"
                >
                    <span class="d-flex align-items-center gap-2">
                        <SvgIcon
                            :name="paramIconMap.geoareaid"
                            role="presentation"
                            size="xs"
                        />
                        {{ (address && radius) ? __('Ret nær placering') : __('Nær placering') }}
                    </span>
                    <SvgIcon
                        name="button-arrow-right"
                        size="mini"
                        role="presentation"
                        class="near-location__arrow"
                    />
                </li>
            </ul>
        </template>
        <div v-else class="jobsearch-dropdown-section">
            <div class="category-header jobsearch-dropdown-section__header">
                {{ __("Nær placering") }}
            </div>
            <div class="px-4">
                <JobsearchNearLocation
                    v-model:address="address"
                    v-model:radius="radius"
                    :show-title="false"
                />
            </div>
            <div class="px-4 mt-3 d-flex justify-content-end">
                <button
                    v-if="store.getters.hasNearLocation"
                    class="btn btn-link text-decoration-none"
                    @click.prevent="emit('close')"
                >
                    <small>
                        {{ __("Gem") }}
                    </small>
                </button>
            </div>
        </div>
    </div>
</template>
